/**
 * Oglinda lui `charReplacementMap` din backend (`RomanianToStandardDeserializer`): exact caracterele
 * pe care `checkDiacriticsInObject` le respinge cu 409 „Diacriticele nu sunt acceptate.".
 */
const INLOCUIRI: Record<string, string> = {
  ă: 'a', â: 'a', î: 'i', ș: 's', ț: 't', ş: 's', ţ: 't',
  Ă: 'A', Â: 'A', Î: 'I', Ș: 'S', Ț: 'T', Ş: 'S', Ţ: 'T',
  ä: 'a', ö: 'o', ü: 'u', Ä: 'A', Ö: 'O', Ü: 'U', é: 'e', É: 'E',
};

const TIPAR = new RegExp(`[${Object.keys(INLOCUIRI).join('')}]`, 'g');

export function faraDiacritice(text: string): string {
  // NFC intai: un „ș" tastat ca s + virgula combinatoare ajunge la backend precompus, deci respins.
  return text.normalize('NFC').replace(TIPAR, (c) => INLOCUIRI[c]);
}

/**
 * Pliaza diacriticele din TOATE string-urile unui corp de cerere, in adancime — backendul verifica
 * la fel, recursiv, prin obiecte imbricate si colectii. Intoarce o copie; intrarea ramane neatinsa.
 */
export function faraDiacriticeInAdancime<T>(valoare: T): T {
  if (typeof valoare === 'string') return faraDiacritice(valoare) as T;
  if (Array.isArray(valoare)) return valoare.map(faraDiacriticeInAdancime) as T;
  if (valoare !== null && typeof valoare === 'object' && Object.getPrototypeOf(valoare) === Object.prototype) {
    return Object.fromEntries(
      Object.entries(valoare).map(([cheie, v]) => [cheie, faraDiacriticeInAdancime(v)])
    ) as T;
  }
  return valoare;
}
